import { createContext, useContext, useState } from "react";

const LocationPermissionContext = createContext();

export const LocationPermissionProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // 👉 Open modal + set message
  const openLocationModal = (msg = "") => {
    setErrorMessage(msg);
    setShowModal(true);
  };

  // 👉 Close modal and clear message
  const closeLocationModal = () => {
    setShowModal(false);
    setErrorMessage("");
  };

  return (
    <LocationPermissionContext.Provider
      value={{
        showModal,
        errorMessage,
        openLocationModal,
        closeLocationModal,
        setErrorMessage,
      }}
    >
      {children}
    </LocationPermissionContext.Provider>
  );
};

export const useLocationPermission = () =>
  useContext(LocationPermissionContext);
